import { useEffect, useState } from 'react';

import { createPitchTrackerConfig, native } from '@muzly/shared';

import { InfoTip } from './InfoTip';
import { InputLevelMeter } from '../../../components';

/**
 * 입력 레벨 미터 패널 — 공용 `InputLevelMeter`(rms dBFS → 바 + 수치)를 재사용하고
 * 현재 config의 `silence_threshold_db`를 게이트선으로 얹는다.
 *
 * 게이트 기준값은 `config_changed` 이벤트로 추적한다(ConfigTuningPanel이 슬라이더
 * 변경분을 같은 채널로 흘려보낸다). 초기값은 mock config 기본치.
 */
const DEFAULT_SILENCE_DB =
  createPitchTrackerConfig().analysis.silenceThresholdDb;

export const InputLevelMeterPanel = () => {
  const [silenceThresholdDb, setSilenceThresholdDb] =
    useState(DEFAULT_SILENCE_DB);

  useEffect(() => {
    return native.on('pitchTrackerEvent', (event) => {
      if (event.type === 'config_changed') {
        setSilenceThresholdDb(event.config.analysis.silenceThresholdDb);
      }
    });
  }, []);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-1">
        <span className="text-xs text-muted-foreground">입력 레벨(dBFS)</span>
        <InfoTip label="입력 레벨 미터 설명">
          마이크 음량을 dBFS로 표시합니다. 0이 최대이고 값이 작을수록(예: −60)
          조용합니다. 주황색 세로선은 silence 게이트선(현재 config의
          silence_threshold_db)으로, 이보다 조용하면 무음으로 보고 음정 분석을
          건너뜁니다.
        </InfoTip>
      </div>
      <InputLevelMeter silenceThresholdDb={silenceThresholdDb} />
    </div>
  );
};
